import { render, staticRenderFns } from "./ChatPopup.vue?vue&type=template&id=7e4fa480&scoped=true"
import script from "./ChatPopup.vue?vue&type=script&lang=js"
export * from "./ChatPopup.vue?vue&type=script&lang=js"
import style0 from "./ChatPopup.vue?vue&type=style&index=0&id=7e4fa480&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e4fa480",
  null
  
)

export default component.exports